import { render, staticRenderFns } from "./FinancialStatement_Component.vue?vue&type=template&id=61aaeedf&scoped=true&"
import script from "./FinancialStatement_Component.vue?vue&type=script&lang=js&"
export * from "./FinancialStatement_Component.vue?vue&type=script&lang=js&"
import style0 from "./FinancialStatement_Component.vue?vue&type=style&index=0&id=61aaeedf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aaeedf",
  null
  
)

export default component.exports